import { Flex } from '@chakra-ui/react';
import { ComponentProps } from 'react';

export const ResponsiveFlex: React.FC<ComponentProps<typeof Flex>> = props => (
  <Flex flexDirection={{ base: 'column', md: 'row' }} {...props}></Flex>
);
